const cs = {
    nav: {
      home: "Domů",
      browse: "Prohlížet svatby",
      dashboard: "Panel",
      messages: "Zprávy",
      profile: "Profil",
      login: "Přihlásit se",
      register: "Registrovat se",
      logout: "Odhlásit se",
      admin: "Admin",
      faq: "FAQ",
      about: "O nás",
      contact: "Kontakt",
      pricing: "Ceník",
      howItWorks: "Jak to funguje",
    },
    auth: {
      login: {
        title: "Vítejte zpět",
        email: "E-mail",
        password: "Heslo",
        button: "Přihlásit se",
        noAccount: "Nemáte účet?",
        register: "Zaregistrujte se",
      },
      register: {
        title: "Vytvořit účet",
        name: "Celé jméno",
        email: "E-mail",
        password: "Heslo",
        role: "Chci...",
        roleHost: "Uspořádat svatbu",
        roleGuest: "Zúčastnit se svateb",
        terms: "Souhlasím s podmínkami a zásadami ochrany osobních údajů",
        button: "Registrovat se",
        hasAccount: "Již máte účet?",
        login: "Přihlaste se",
      },
    },
  review: {
    title: "Write a Review",
    description: "Share your experience with",
    ratingLabel: "How would you rate your experience?",
    rating1: "Poor",
    rating2: "Fair",
    rating3: "Good",
    rating4: "Very Good",
    rating5: "Excellent",
    commentLabel: "Your Review",
    optional: "optional",
    commentPlaceholder: "Tell others about your experience...",
    for: "Review for",
    submit: "Submit Review",
    success: "Review submitted successfully!",
    error: "Failed to submit review",
    selectRating: "Please select a rating",
    noReviews: "No reviews yet",
    received: "Reviews Received",
    averageRating: "Average Rating",
    writeReview: "Write Review",
    reviewed: "Reviewed",
    completedWedding: "This wedding has been completed. You can now write a review.",
  },

    common: {
      loading: "Načítání...",
      error: "Došlo k chybě",
      success: "Úspěch",
      save: "Uložit",
      cancel: "Zrušit",
      delete: "Smazat",
      edit: "Upravit",
      back: "Zpět",
      next: "Další",
      language: "Jazyk",
      currency: "Měna",
      search: "Hledat",
      filter: "Filtrovat",
      all: "Vše",
      none: "Žádné",
      yes: "Ano",
      no: "Ne",
    },
    footer: {
      about: "O nás",
      privacy: "Soukromí",
      terms: "Podmínky",
      contact: "Kontakt",
      copyright: "© 2024 WEDVAYA. Všechna práva vyhrazena.",
    },
  };

export default cs;
